export default ({ username }) => {
  window.location.href = encodeURI(
    `mailto:verification@mrq.com?subject=Hi MrQ, can you verify my account? My username is ${username}&body= Just attach your documents to this email and we'll review them shortly.`
  );
};
